/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// REPORT DETAILS : AREA : SCHEDULE : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	schedule: {
		'& .group': {
			flexWrap: 'wrap',
			'& .schedule-type, .schedule_options':{
				'& .list-item .option-text': {
					opacity: 1
				}
			},
			'& .schedule-type':{
				margin: replacePXinStringWithEM('15px 120px 0 0'),
			},
			'& .schedule_options': {
				margin: replacePXinStringWithEM('15px 0 0 0'),
				'& .enddate': {
					zIndex: 5,
					margin: replacePXinStringWithEM('15px 80px 0 0')
				},
				'& .email-list': {
					margin: replacePXinStringWithEM('15px 0 0 80px'),
					padding: replacePXinStringWithEM('0 15px 0 0'),
					height: pxToEm(350),
					overflowY: 'scroll'
				},
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[mediaQuery.reportDetailPage]: {
		schedule: {
			'& .group': {
				flexDirection: 'column',
				flexWrap: 'warp',
				'& .schedule-type, .schedule_options': {
					margin: replacePXinStringWithEM('15px 0'),
					'& .list-item .option-text': {
						opacity: 1
					}
				},
				'& .schedule_options': {
					'& .enddate, .email-list': {
						margin: replacePXinStringWithEM('15px 0'),
					}
				},
				'& .name-icon-text':{
					flexWrap: 'nowrap',
					flexDirection: 'row'
				}
			}
		}
	},
});